// Find job status option by its value
export function findStatusByValue(jobStatusOptions, value) {
    if (!Array.isArray(jobStatusOptions)) return undefined;
    return jobStatusOptions.find((r) => r.id === value);
}

// Find job type option by its value
export function findTypeByValue(jobTypeOptions, value) {
    if (!Array.isArray(jobTypeOptions)) return undefined;
    return jobTypeOptions.find((r) => r.id === value);
}

// Cleans the job filter object by removing empty or null values
export function cleanJobFilter(filter, jobRange, jobSort) {
    const filtered = Object.fromEntries(
        Object.entries(filter)
            .map(([k, v]) => [
                k,
                (['jobType', 'jobStatus'].includes(k) && v && typeof v === 'object')
                    ? v.value ?? v.id ?? ''
                    : v,
            ])
            .filter(([_, v]) => v != null && v !== ''),
    );
    filtered.jobRange = jobRange;
    filtered.jobSort = jobSort;
    return filtered;
}